import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const MSAuthCallback: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const status = params.get('status');
        const message = params.get('message');
        console.log('auth/callback', status, message);
        if (window.opener) {
            // 부모 창으로 메시지 전송
            (window.opener as Window).postMessage(
                {
                    type: 'AUTH_RESULT',
                    status,
                    message,
                },
                window.location.origin
            );


            // 팝업 닫기
            window.close();
        }
    }, [location]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <h2>인증 처리 중입니다...</h2>
        </div>
    );
};
